import isEmpty from 'lodash/isEmpty'
import { useSearchParam } from 'react-use'
import { jsonTryParse } from '@ztechapps/common.utils'

export const useAccessTokenParam = (): string | null | undefined => {
  let params = useSearchParam('params')
  let accessToken = null

  //try to check on the params, if there is value, get it
  if (!isEmpty(params)) {
    params = decodeURIComponent(params)
    const paramResult = jsonTryParse(atob(params))

    accessToken = paramResult?.accessToken
  }

  return accessToken
}
